import React, { Component } from 'react';
import { /*Badge, DropdownItem, DropdownMenu, DropdownToggle,*/ Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/lvin-logo2.png'
import sygnet from '../../assets/img/brand/sygnet.svg'

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo,  height: 35, alt: 'Logo' }}
          minimized={{ src: sygnet, height: 30, alt: 'lvinlife' }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <h3>{this.props.user}</h3>
        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">

          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
